import { useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

export default function ContactForm() {
  const [form, setForm] = useState({
    nom: "",
    prenom: "",
    entreprise: "",
    email: "",
    telephone: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/user/contact`,
        form
      );
      toast.success("Votre message a été transmis à l'administrateur !");
      setForm({
        nom: "",
        prenom: "",
        entreprise: "",
        email: "",
        telephone: "",
        message: "",
      });
    } catch (err) {
      toast.error("Erreur d'envoi du message !");
    }
  };

  return (
    <div className="zoneContactForm">
      <form id="contactform" onSubmit={handleSubmit}>
        <h3>Contactez nous pour une annonce publicitaire :</h3>
        <input
          type="text"
          name="nom"
          placeholder="Nom"
          value={form.nom}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="prenom"
          placeholder="Prénom"
          value={form.prenom}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="entreprise"
          placeholder="Nom de l'entreprise"
          value={form.entreprise}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="telephone"
          placeholder="Téléphone"
          value={form.telephone}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder="Message"
          value={form.message}
          onChange={handleChange}
          required
        />
        <button className="button" type="submit">
          Envoyer
        </button>
        <ul>
          Forfait pour la publication de votre publicité : 
          <li><strong>10000 FCFA</strong> la semaine</li> 
          <li><strong>30000 FCFA</strong> le mois</li>
        </ul>
      </form>
    </div>
  );
}
